import {
	GET_VIDEOS,
	GET_VIDEOS_PROM,
	GET_VIDEOS_TESTI,
	GET_HOME_VIDEO
} from './Types';

export const getVideos = () => { return { type: GET_VIDEOS } };
export const getVideosProm = () => { return { type: GET_VIDEOS_PROM } };
export const getVideosTesti = () => { return { type: GET_VIDEOS_TESTI } };
export const getHomevideo = () => { return { type: GET_HOME_VIDEO } };


// WEBPACK FOOTER //
// ./src/actions/VideosActions.js